import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { useBridge } from '../../../application/hooks/useBridge';
import useBeacon, {
  ClkBtnSubEventNm,
} from '../../../application/hooks/useBeacon';
import { HeadTitle, Button, SpacerSection, Tsmbd18 } from 'oui';

import result_doc from '../../../assets/images/feature/feature-result-empty.png';

import hd from '../../../assets/images/loan/hd_result.png';
import sbi_kt from '../../../assets/images/loan/sbi_result_kt.png';
import sbi_skt from '../../../assets/images/loan/sbi_result_skt.png';
import kbank_result from '../../../assets/images/loan/kbank_result.png';
import shinhan_result from '../../../assets/images/loan/shinhan_result.png';
import kjbank_result_1 from '../../../assets/images/loan/kjbank_result_1.png';
import kjbank_result_2 from '../../../assets/images/loan/kjbank_result_2.png';
import kjbank_result_3 from '../../../assets/images/loan/kjbank_result_3.png';

import eventTimer from '../../../application/helper/eventTimer';
import { PAGE_NM } from '../../../application/types/types';
import { beaconSelector } from '../../../application/recoil/selector';

import * as S from './EmptyResult.style';

interface IEmptyResultProps {
  getPreReqTime: string;
  onClickMainBtn: () => void;
}

const EmptyResult = ({ getPreReqTime, onClickMainBtn }: IEmptyResultProps) => {
  const br: any = useBridge();
  const { media } = useParams();
  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.RESULT_EMPTY,
  });

  const sendBeaconClick = (subEventName: string) => {
    beacon.sendClkBanner({
      events: {
        subEventName: subEventName,
      },
    });
  };

  const sendBeaconView = (subEventName: string) => {
    beacon.sendViewBanner({
      events: {
        subEventName: subEventName,
      },
    });
  };

  const loanList = [
    {
      id: 1,
      type: 'hd',
      src: hd,
      date: { start: '2025-01-01T00:00:00', end: '2025-06-30T23:59:59' },
    },
    {
      id: 2,
      type: 'sbi',
      src: media === 'skt' ? sbi_skt : sbi_kt,
      date: { start: '2025-01-01T00:00:00', end: '2025-06-30T23:59:59' },
    },
    {
      id: 3,
      type: 'kbank',
      src: kbank_result,
      date: { start: '2025-01-01T00:00:00', end: '2025-06-30T23:59:59' },
    },
    {
      id: 4,
      type: 'shinhan',
      src: shinhan_result,
      date: { start: '2025-01-01T00:00:00', end: '2025-06-30T23:59:59' },
    },
    {
      id: 5,
      type: 'kjbank_1',
      src: kjbank_result_1,
      date: { start: '2026-01-02T09:00:00', end: '2027-01-31T23:59:59' },
    },
    {
      id: 6,
      type: 'kjbank_2',
      src: kjbank_result_2,
      date: { start: '2026-01-02T09:00:00', end: '2027-01-31T23:59:59' },
    },
    {
      id: 7,
      type: 'kjbank_3',
      src: kjbank_result_3,
      date: { start: '2026-01-02T09:00:00', end: '2027-01-31T23:59:59' },
    },
  ];

  const onClickloanLink = (type: string) => {
    if (type === 'shinhan') {
      const url =
        'https://www.shinhansavings.com/RMM?d=adsaitdol_m&utm_source=pass&utm_medium=cpa&utm_campaign=m_saitdol&utm_term=PASS_%EB%B9%84%EA%B5%90%EB%8C%80%EC%B6%9C_%EB%B6%80%EA%B2%B0%ED%8E%98%EC%9D%B4%EC%A7%80_%EC%82%AC%EC%9E%87%EB%8F%8C&src=wnut_pl&kw=00694E';

      sendBeaconClick(ClkBtnSubEventNm.Shinhan);

      br?.openExternalBrowser({
        url,
      });

      return;
    }

    const trackCdList: { [key: string]: { [key: string]: string } } = {
      hd: { skt: 'A007BC04', kt: 'D007BC04', lgu: 'B007BC04' },
      sbi: { skt: 'A007BB05', kt: 'D007BB05' },
      kbank: { skt: 'A007BB06', kt: 'D007BB06', lgu: 'B007BB06' },
      kjbank_1: { skt: 'A007BB10', kt: 'D007BB10', lgu: 'B007BB10' },
      kjbank_2: { skt: 'A007BB11', kt: 'D007BB11', lgu: 'B007BB11' },
      kjbank_3: { skt: 'A007BB09', kt: 'D007BB09', lgu: 'B007BB09' },
    };

    if (media === 'skt') {
      br?.requestAddService({
        type: 'EBMP',
        url:
          process.env.REACT_APP_EBMP_SKT_URI +
          `?extraParam=3&extraParam2=${trackCdList[type][media]}`,
      });
    } else if (media === 'kt') {
      br?.requestAddService({
        type: 'EBMP',
        url:
          process.env.REACT_APP_EBMP_KT_URI +
          `?src_cd=${trackCdList[type][media]}`,
      });
    } else if (media === 'lgu') {
      const redirectYn = 'Y';
      br?.requestAddService({
        type: 'EBMP',
        url: `?tabSeq=1&track_cd_type=${trackCdList[type][media]}&redirectYn=${redirectYn}`,
      });
    }
  };

  useEffect(() => {
    beacon.sendViewPage();

    /*const shinhanLoan = loanList.find((list) => list.type === 'shinhan');
    if (shinhanLoan) {
      sendBeaconView(ClkBtnSubEventNm.Shinhan);
    }*/
  }, []);

  return (
    <>
      <SpacerSection
        size={'md'}
        children={
          <img
            src={result_doc}
            alt={'result-doc'}
            style={{ width: '100%', height: 'auto' }}
          />
        }
      />
      <S.HeadTitleWrap>
        <HeadTitle
          textTitle={'이번에는\n대출이 어렵습니다'}
          subTitle={`${getPreReqTime}에 진행한 가심사 결과`}
        />
      </S.HeadTitleWrap>
      <S.Divider />
      <S.ListTitle>
        <div>
          <Tsmbd18 text="괜찮아요! 당신을 위한" />
        </div>
        <div>
          <Tsmbd18 text="또 다른 상품을 준비했어요." />
        </div>
      </S.ListTitle>
      {loanList.map(({ id, type, src, date }) => {
        if (
          !eventTimer(
            new Date(date.start).toString(),
            new Date(date.end).toString(),
            new Date().toString(),
          )
        )
          return null;

        return (
          <div key={id} onClick={() => onClickloanLink(type)}>
            <S.AdImage src={src} alt="" />
          </div>
        );
      })}
      <S.BottomEmptySpace />
      {/* <SideBox>
        <Explain
          title={'신용점수를 올리면 많은 상품을 볼 수 있어요'}
          children={CREDIT_SCORE.map((item: any) => {
            return (
              <ExplainItem
                key={item.subTitle}
                title={item.title}
                subTitle={item.subTitle}
                avatar={{
                  source: item.source,
                  alt: item.alt,
                }}
              />
            );
          })}
        />
      </SideBox> */}

      <S.FloatingBox>
        <Button
          flexible={true}
          configuration={'lightContained'}
          onClick={onClickMainBtn}
          color="default"
        >
          <S.ButtonText>다양한 대출 상품 보기</S.ButtonText>
        </Button>
      </S.FloatingBox>
    </>
  );
};

export default EmptyResult;
